import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrismDialogService } from '@shure/prism-angular-components';

import { AddDevicesDialogComponent } from './add-devices-dialog.component';

@Component({
	standalone: true,
	selector: 'sh-add-devices-dialog-entry',
	template: ''
})
export class AddDevicesDialogEntryComponent {
	constructor(dialogService: PrismDialogService, router: Router, activatedRoute: ActivatedRoute) {
		dialogService
			.openDialog<AddDevicesDialogComponent, void, unknown>(AddDevicesDialogComponent)
			.afterClosed$.subscribe(() => {
				router.navigate(['..'], { relativeTo: activatedRoute });
			});
	}
}
